
// import stats from "../raws/stats.json"

export default {
  url({ period, restaurantId }) {
    let url = `https://api.monrapidoo.com/rapidoo-aggregation/platform/stats?group=ultraxeno`
    if (period) {
      url += `&period=${period}`
    }
    if (restaurantId) {
      url += `&restaurantId=${restaurantId}`
    }
    return url
  },

  parse(raw = {}, payload = {}) {
    // raw = stats
    if (!raw || raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        data: null,
      }
    }

    return {
      statusCode: 200,
      data: raw.data,
    }
  },
}
